import { observer } from "mobx-react-lite";
import { useInitialEffect } from "core/react-utils";
import { AnalyticsStore } from "stores";
import { Card } from "semantic-ui-react";
import { avgDisplay, numberWithCommas } from "core/utils";
import { displayStackedBarChart } from "core/charts";
import { StatusChartData } from "models/analytics";
import ChartTab from "./chart-tab";

const emptyData = new StatusChartData();

const TestRunsTab = observer(() => {
  const form = AnalyticsStore.statusChartData.options;
  const data = AnalyticsStore.statusChartData.data || emptyData;

  useInitialEffect(() => {
    AnalyticsStore.loadStatusChartData();
  });

  return (
    <ChartTab
      chartData={AnalyticsStore.statusChartData}
      drawChart={(id: string, labels: string[]) => {
        const counts = data.counts(form.frequency, form.dates);
        return displayStackedBarChart(id, labels, [
          {
            label: "Passed",
            backgroundColor: "#008000",
            data: counts.map((c) => c.passed),
          },
          {
            label: "Failed",
            backgroundColor: "#ed1d0a",
            data: counts.map((c) => c.failed),
          },
          {
            label: "Canceled",
            backgroundColor: "#ddd",
            data: counts.map((c) => c.canceled),
          },
        ]);
      }}
      header={() => (
        <Card.Group centered>
          <Card>
            <Card.Content>
              <div className="name">Total Test Runs</div>
              <div className="value">{numberWithCommas(data.total)}</div>
            </Card.Content>
          </Card>
          <Card>
            <Card.Content>
              <div className="name">Passed Test Runs</div>
              <div className="value">{numberWithCommas(data.passed)}</div>
            </Card.Content>
          </Card>
          <Card>
            <Card.Content>
              <div className="name">Failed Test Runs</div>
              <div className="value">{numberWithCommas(data.failed)}</div>
            </Card.Content>
          </Card>
          <Card>
            <Card.Content>
              <div className="name">Avg Runs Per Day</div>
              <div className="value">{avgDisplay(data.total, form.numberOfDays)}</div>
            </Card.Content>
          </Card>
          <Card>
            <Card.Content>
              <div className="name">Test Run Minutes</div>
              <div className="value">{numberWithCommas(data.testRunMinutes)}</div>
            </Card.Content>
          </Card>
        </Card.Group>
      )}
    />
  );
});

export default TestRunsTab;
